import { render, staticRenderFns } from "./intodctionInstitution.vue?vue&type=template&id=5ddb5f3a&scoped=true&"
import script from "./intodctionInstitution.vue?vue&type=script&lang=js&"
export * from "./intodctionInstitution.vue?vue&type=script&lang=js&"
import style0 from "./intodctionInstitution.vue?vue&type=style&index=0&id=5ddb5f3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb5f3a",
  null
  
)

export default component.exports